import * as ImageSize from "utils/ImageSize";
import FocalPoint from "components/FocalPoint";
import getChapterNumber from "selectors/chapter/getChapterNumber";
import getParentChapterSlug from "selectors/chapter/getParentChapterSlug";
import Image from "components/Image";
import makeGetChapterEntity from "selectors/chapter/makeGetChapterEntity";
import PropTypes from "prop-types";
import React from "react";
import TransparentPixel from "components/TransparentPixel";
import { connect } from "react-redux";
import { keyboardEventPassthroughHandler } from "utils/keyboardEventPassthroughHandler";

class ChapterSlideshowTile extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    thumbnail: PropTypes.shape({
      src: PropTypes.string,
    }),
    title: PropTypes.string.isRequired,
  };

  render() {
    const thumbnailContainer = (
      <div className="chapter-slideshow-tile-thumbnail">
        <FocalPoint
          containThreshold={Infinity}
          fitMode="cover"
          focalPoint={this.props.thumbnail}
        >
          <Image size={ImageSize.MEDIUM} src={this.props.thumbnail.src} />
        </FocalPoint>
      </div>
    );

    return (
      <div
        aria-label={this.props.title}
        className="chapter-slideshow-tile"
        onClick={this.props.onClick}
        onKeyUp={keyboardEventPassthroughHandler(this.props.onClick)}
        role="button"
        tabIndex={0}
      >
        <TransparentPixel height="100vh" />
        {thumbnailContainer}
        <div className="chapter-slideshow-tile-text-container">
          <div className="overlay" />
          <div className="chapter-slideshow-tile-description">
            <div className="chapter-slideshow-tile-title font-size--copy--large font-style--header-3">
              {this.props.title}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const makeMapStateToProps = () => {
  const getChapterEntity = makeGetChapterEntity();
  return (state, ownProps) => {
    const chapterEntity = getChapterEntity(state, ownProps);

    const parentChapterSlug = getParentChapterSlug(state, ownProps);
    return {
      chapterNumber: getChapterNumber(state, ownProps),
      onClick: () =>
        ownProps.onClick({
          chapterId: ownProps.chapterId,
          chapterKey: parentChapterSlug || chapterEntity.slugs[0],
          chapterTitle: chapterEntity.title,
          routeName: parentChapterSlug ? "subchapter" : "chapter",
          subchapterKey: parentChapterSlug ? chapterEntity.slugs[0] : null,
        }),
      thumbnail:
        chapterEntity.thumbnail &&
        state.story.entities.images[chapterEntity.thumbnail],
      title: chapterEntity.title,
    };
  };
};

export default connect(makeMapStateToProps)(ChapterSlideshowTile);
